<!--
* 组件名 : 第五章子章节年份标题
* 开发者 : JY
*
* 参数:
*   pageData         { Object } -  章节首页数据
*
* 事件: null
*
-->
<template>
  <div class="v-chapter-years-title">
    <h2 class="years-title num" v-html="years"></h2>
    <h4 class="type-title years-content">{{ pageData.data.content }}</h4>
    <div class="chapter-desc set-font-size" v-if="pageData.data.description">
      <p v-html="pageData.data.description" />
    </div>
  </div>
</template>

<script>
export default {
  name: "v-chapter-years-title",
  props: {
    pageData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      years: "",
    };
  },
  created() {
    this.split_years_num();
  },
  methods: {
    /**
     * 分割年份字符串，做动画用
     */
    split_years_num() {
      if (this.pageData.data.title.indexOf("-") < 0) {
        this.years = this.pageData.data.title;
      } else {
        let num = this.pageData.data.title.split("-");
        this.years = `<span>${num[0]}</span><span> - </span><span>${num[1]}</span>`;
      }
    },
  },
};
</script>

<style lang="scss">
.v-chapter-years-title {
  padding-top: 140px;
  padding-bottom: 90px;
  max-width: 910px;
  margin: auto;

  .years-title {
    margin-bottom: 32px;

    span {
      font: {
        size: inherit;
        family: inherit;
      }
    }
  }

  .chapter-desc {
    width: 900px;
    line-height: 1.8;
    margin: auto;
    margin-top: 112px;
    padding: {
      bottom: 36px;
    }

    p {
      font-size: var(--font-size);
    }
  }
}

body[data-lang="zh-TW"],
body[data-lang="zh-CN"] {
  .v-chapter-years-title {
    .chapter-desc {
      text-indent: 2em;
    }
  }
}
</style>
